import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Chip
} from '@mui/material';
import { FormatBold, TextFields } from '@mui/icons-material';
import { getComparisonTablePresetNames, getComparisonTablePreset } from '../textStyle';

const ComparisonTablePresetSelector = ({ onStyleSelect, currentStyle = null, presetFilter = null }) => {
  const allComparisonTablePresetNames = getComparisonTablePresetNames();
  
  // Filter presets based on the filter prop
  const presetNames = presetFilter 
    ? allComparisonTablePresetNames.filter(presetFilter)
    : allComparisonTablePresetNames;
    
  console.log('🟢 ComparisonTablePresetSelector rendered with presets:', presetNames, 'currentStyle:', currentStyle, 'filter applied:', !!presetFilter);

  const handleStyleSelect = (presetName) => {
    const preset = getComparisonTablePreset(presetName);
    console.log('🎨 ComparisonTablePresetSelector: Applying preset:', presetName, preset);
    onStyleSelect(presetName, preset);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <TextFields fontSize="small" sx={{ mr: 1 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
          Preset Comparison Table Styles
        </Typography>
      </Box>
      
      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
        Click any style to quickly apply a complete comparison table styling set.
      </Typography>

      <Grid container spacing={1}>
        {presetNames.map((presetName) => {
          const preset = getComparisonTablePreset(presetName);
          const isSelected = currentStyle === presetName;
          
          return (
            <Grid item key={presetName}>
              <Paper
                elevation={isSelected ? 3 : 1}
                sx={{
                  p: 1.5,
                  cursor: 'pointer',
                  border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                  borderRadius: 1,
                  backgroundColor: isSelected ? '#e3f2fd' : '#ffffff',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: isSelected ? '#e3f2fd' : '#f5f5f5',
                    borderColor: '#1976d2',
                    transform: 'translateY(-1px)'
                  },
                  minWidth: 100,
                  maxWidth: 140
                }}
                onClick={() => handleStyleSelect(presetName)}
              >
                <Typography
                  variant="caption"
                  sx={{
                    ...preset,
                    display: 'block',
                    textAlign: 'center',
                    wordBreak: 'break-word',
                    lineHeight: 1.2,
                    fontSize: '11px'
                  }}
                >
                  {presetName.charAt(0).toUpperCase() + presetName.slice(1)}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ComparisonTablePresetSelector; 